import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a9e8506"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pages"
};
const _hoisted_2 = {
  class: "pages-view"
};
import { useRouter, useRoute } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const onChange = tab => router.push(tab.path);
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_view)])]);
    };
  }
};